export default __webpack_public_path__ + "static/media/angolo.81e13732.avif";